import { useEffect } from 'react'

const useCountdown = (
  value: number,
  setter: (value: number | null) => void
) => {
  useEffect(() => {
    if (value === 0) {
      setter(null)
    }

    if (!value) return

    const intervalId = setInterval(() => {
      setter(value - 1)
    }, 1000)

    return () => clearInterval(intervalId)
  }, [value])

  return value
}

export default useCountdown
